import React from 'react';

const Footer: React.FC = () => {
  // 预留底部占位，避免 `position: fixed` 覆盖页面内容
  const FOOTER_SPACER_HEIGHT = 64;

  return (
    <>
      <div style={{ height: FOOTER_SPACER_HEIGHT }} aria-hidden="true" />
      <div
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 50,
          background: '#ffffff',
          borderTop: '1px solid #f1f5f9',
        }}
      >
        <div
          style={{
            maxWidth: 1400, // 与 ProLayout 的 style maxWidth 保持一致
            margin: '0 auto',
            padding: '12px 24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 10,
            whiteSpace: 'nowrap',
          }}
        >
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'gray', textDecoration: 'none' }}
          >
            苏ICP备14049145号-1
          </a>
          <span style={{ color: 'gray' }}>Copyright©2025</span>
        </div>
      </div>
    </>
  );
};

export default Footer;
